import { Container } from "@mui/material";
import SolicitarFirmaDecano from "../../componentes/Certificados/SolicitarFirmaDecano";

export const SolicitarFirmaPage:React.FC<{}> =() =>{
    return(
        <Container sx={{mt:4}}>
            <SolicitarFirmaDecano />
        </Container>
    );
}